import Layout from 'lib/components/Layout'

import AboutSection from 'pages/Ruanica/Home/sections/About'
import FeaturesSection from 'pages/Ruanica/Home/sections/Features'
import HeroSection from 'pages/Ruanica/Home/sections/Hero'
import StreamSection from 'pages/Ruanica/Home/sections/Stream'
import JoinSection from 'pages/Ruanica/Home/sections/Join'
import StorySection from 'pages/Ruanica/Home/sections/Story'

import { RUANICA_NAVIGATION } from './navigation'

const Home = () => (
  <Layout navigation={RUANICA_NAVIGATION} homeHref="/ruanica" showLogo={false}>
    <HeroSection />

    <AboutSection />

    <FeaturesSection />

    <StreamSection />

    <JoinSection />

    <StorySection />
  </Layout>
)

export default Home
